import { Theme } from "@mui/material";

/* eslint-disable */
import RO from "@/assets/fonts/ROsanswebtextregular.woff";

import { darkGrey, darkBlue, white, error, warning, success } from "@/theme/colors";

declare module "@mui/material/Button" {
  interface ButtonPropsSizeOverrides {
    extraLarge: true;
  }
  interface ButtonPropsVariantOverrides {
    rounded: true;
  }
}

declare module "@mui/material/Button" {
  interface ButtonPropsSizeOverrides {
    extraLarge: true;
  }
  interface ButtonPropsVariantOverrides {
    rounded: true;
  }
}

const components: Theme["components"] = {
  MuiSelect: {
    variants: [
      {
        props: { color: "secondary" },
        style: {
          color: "white",
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(255, 255, 255, 0.7)",
          },
          "& .MuiSelect-iconOutlined": {
            color: "white",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderWidth: 1,
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(255, 255, 255, 0.4)",
          },
        },
      },
    ],
  },
  MuiButton: {
    variants: [
      {
        props: { size: "extraLarge" },
        style: {
          fontSize: "16px",
          lineHeight: "1.5em",
          padding: "16px 24px",
          textTransform: "none",

          ".MuiButton-endIcon": {
            marginLeft: "16px",
          },
        },
      },
      {
        props: { variant: "rounded" },
        style: {
          background: `${darkBlue}`,
          borderRadius: "28px",
          boxShadow:
            "0px 3px 1px -2px rgb(0 0 0 / 0%), 0px 2px 4px 0px rgb(3 104 155 / 15%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
          color: `${white}`,

          "&:hover": {
            background: `${darkBlue}`,
          },
        },
      },
      {
        props: { variant: "rounded", color: "primary" },
        style: {
          background: `${darkBlue}`,
          borderRadius: "28px",
          color: `${white}`,

          "&:hover": {
            background: `${darkBlue}`,
          },
        },
      },
      {
        props: { variant: "rounded", color: "secondary" },
        style: {
          background: `${white}`,
          borderRadius: "28px",
          color: `${darkGrey}`,

          "&:hover": {
            background: `${white}`,
          },
        },
      },
      {
        props: { variant: "rounded", color: "success" },
        style: {
          background: `${success}`,
          borderRadius: "28px",
          color: `${white}`,

          "&:hover": {
            background: `${success}`,
          },
        },
      },
      {
        props: { variant: "rounded", color: "warning" },
        style: {
          background: `${warning}`,
          borderRadius: "28px",
          color: `${white}`,

          "&:hover": {
            background: `${warning}`,
          },
        },
      },
      {
        props: { variant: "rounded", color: "error" },
        style: {
          background: `${error}`,
          borderRadius: "28px",
          color: `${white}`,

          "&:hover": {
            background: `${error}`,
          },
        },
      },
    ],
    styleOverrides: {
      contained: {
        // The default shadow it to dark for our button color
        boxShadow:
          "0px 3px 1px -2px rgb(0 0 0 / 0%), 0px 2px 4px 0px rgb(3 104 155 / 15%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
      },
    },
  },
  MuiCssBaseline: {
    styleOverrides: `
      @font-face {
        font-family: '"RO"';
        font-style: normal;
        font-weight: 400;
        src: url(${RO}) format('woff');
      }
    `,
  },
};

export default components;
